module.exports = __webpack_public_path__ + "img/zhth-2.61999de6.png";